import { createAsyncThunk } from '@reduxjs/toolkit';
import AjaxUtil from 'common/Js/AjaxHelper/AjaxUtil';
import { HOST_URL, isRenderedAsIframeInNewUI } from 'config';
import { User } from '.';
import { getClientExpiration } from 'layouts/customersApi';
import scannerAPI from 'pages/ScannerPage/api/scannerApi';
import { postIframeMessage } from 'utils/postPerentIframeMessage';
import { SESSION_LOGGING_MESSAGE_KEY } from 'pages/SiteLoadingPage/constants';

export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
  const url = HOST_URL + '/WebApp/Settings/GetUser';

  if (isRenderedAsIframeInNewUI) {
    postIframeMessage(SESSION_LOGGING_MESSAGE_KEY, {
      step: 'getUser:start',
      details: { url }
    });
  }
  try {
    const user = (await AjaxUtil.sendGet(url)) as User;
    if (isRenderedAsIframeInNewUI) {
      postIframeMessage(SESSION_LOGGING_MESSAGE_KEY, {
        step: 'getUser:success',
        details: { email: user?.email }
      });
    }
    return user;
  } catch (error) {
    if (isRenderedAsIframeInNewUI) {
      postIframeMessage(SESSION_LOGGING_MESSAGE_KEY, {
        type: 'error',
        step: 'getUser:error',
        details: {
          error: JSON.stringify(error),
          url,
          message: 'GetUser request failed'
        }
      });
    }
    throw error;
  }
});

export const initScannerData = createAsyncThunk('user/initScannerData', async () => {
  return (await scannerAPI.initScannerData()) as any[];
});

export const setExpiration = createAsyncThunk('user/setExpiration', async (clientToken: string, AppThunk) => {
  const expirationDate = await getClientExpiration(clientToken);
  if ((expirationDate && new Date(expirationDate) > new Date()) || expirationDate === '') {
    AppThunk.dispatch(initScannerData());
  }
  return expirationDate;
});
